import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericModal from '../../../components/modal/GenericModal';
import { usePostRequest } from '../../../hooks/usePostRequest/usePostRequest';
import { responseCode200, mostrarMensajeDeErrorConToast } from '../../../consumers/httpRequiestsUtils';
import { accionSobrePrestamoAPI } from '../../../consumers/backendApisUrls';
import { GENERIC_SUCCESS_TOAST_MESSAGE } from '../../../constants/hardCodedConstants';

// Configuración por acción
const ACCION_CONFIG = {
    APROBAR: {
        titulo:         "Confirmar Aprobación",
        mensaje:        "¿Está seguro que desea aprobar esta solicitud?",
        labelBtn:       "Aprobar",
        classBtn:       "btn generic-button-buscador generic-button-hover-verde",
        idEstado:       14,
        conComentario:  false,
    },
    RECHAZAR: {
        titulo:         "Confirmar Rechazo",
        mensaje:        "¿Está seguro que desea rechazar esta solicitud? Ingrese un comentario.",
        labelBtn:       "Rechazar",
        classBtn:       "btn generic-button-buscador generic-button-hover-rojo",
        idEstado:       15,
        conComentario:  true,
    },
    OBSERVAR: {
        titulo:         "Registrar Observación",
        mensaje:        "Ingrese el motivo de la observación para que el colaborador pueda corregirla.",
        labelBtn:       "Observar",
        classBtn:       "btn generic-button-buscador generic-button-hover-amarillo",
        idEstado:       13,
        conComentario:  true,
    },
    REVERTIR: {
        titulo:         "Revertir Solicitud",
        mensaje:        "¿Está seguro que desea revertir esta solicitud rechazada?",
        labelBtn:       "Revertir",
        classBtn:       "btn generic-button-buscador generic-button-hover-verde",
        idEstado:       16,
        conComentario:  false,
    },
};

const AprobarPrestamo = ({ idPrestamo, accion, showModal, refreshPage, nivel }) => {
    const config = ACCION_CONFIG[accion];
    const [comentario, setComentario] = useState("");
    const [enviando, setEnviando]     = useState(false);
    const [executePostRequest]        = usePostRequest();

    const handleConfirmar = async () => {
        if (config.conComentario && !comentario.trim()) {
            toast.warn("El comentario es obligatorio.");
            return;
        }

        const payload = {
            IdPrestamo:  idPrestamo,
            IdEstado:    config.idEstado,
            Comentario:  comentario.trim() || null,
        };

        setEnviando(true);
        try {
            const response = await executePostRequest(accionSobrePrestamoAPI(), payload);
            if (responseCode200(response)) {
                toast.success(response?.data?.Message || GENERIC_SUCCESS_TOAST_MESSAGE);
                showModal();
                await refreshPage();
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        } finally {
            setEnviando(false);
        }
    };

    if (!config) return null;

    return (
        <GenericModal titulo={config.titulo} showModal={showModal} width='500px'>
            <div className="modal-body">

                <div className="col-sm-12 mb-3">
                    <p className="ficha-declaracion-jurada-message">{config.mensaje}</p>
                </div>

                {config.conComentario && (
                    <div className="col-sm-12 mb-3">
                        <label className="modal-label">
                            Comentario <span className="required">*</span>
                        </label>
                        <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Ingrese un comentario..."
                            value={comentario}
                            onChange={e => setComentario(e.target.value)}
                        />
                    </div>
                )}

                {!config.conComentario && accion === 'APROBAR' && nivel === 2 && (
                    <div className="col-sm-12 mb-3">
                        <label className="modal-label">Comentario de aprobación</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Ingrese un comentario (opcional)..."
                            value={comentario}
                            onChange={e => setComentario(e.target.value)}
                        />
                    </div>
                )}

            </div>

            <div className="modal-footer">
                <button type="button" className="btn btn-primary generic-button-ficha mr-2"
                    onClick={showModal}>
                    Cancelar
                </button>
                <button
                    type="button"
                    className={config.classBtn}
                    onClick={handleConfirmar}
                    disabled={enviando}>
                    {enviando
                        ? <><FontAwesomeIcon icon="spinner" className="spinner mr-1"/> Procesando...</>
                        : config.labelBtn
                    }
                </button>
            </div>
        </GenericModal>
    );
};

export default AprobarPrestamo;
